export const SET_CYPHER_SECRET = 'SET_CYPHER_SECRET';